export default "__VITE_ASSET__nsXGmuE2__"